import * as React from 'react';
import { Trans } from '@lingui/macro';

export const Title = () => <Trans>Section introuvable</Trans>;
